// eBay analytics — dev-only until the eBay launch. No `feature` key: the Amazon
// marketplace capability gates do not apply to an eBay account. The route itself is
// hard-blocked outside development by devOnlyPaths in src/router/index.js.
import { unansweredMessagesCount } from '@/stores/ebayMessages.js';

// `badgeContent` is read by VerticalNavLink on every render, so a getter here tracks
// `unansweredMessagesCount` reactively (a plain nav config has no other way to carry live
// data). Hidden at zero/unknown rather than showing "0". Deliberately a plain ref import,
// not `useEbayMessagesStore()`: that store's setup chains into `useEbayAccountStore()` →
// `useAccountStore()`, which calls `useRoute()`/`useRouter()` — those throw
// ("inject() can only be used inside setup()") when the chain's first call happens outside
// a mounted component, which a nav-render getter cannot guarantee. A ref needs no
// injection context.
const unansweredBadge = () => {
  const count = unansweredMessagesCount.value;
  return count > 0 ? String(count) : undefined;
};

export default [
  {
    title: 'eBay',
    channel: 'ebay',
    icon: { icon: 'selfhst:ebay' },
    envOnly: 'development',
    children: [
      {
        title: 'Overview',
        action: 'read',
        subject: 'User',
        to: 'ebay-overview',
        icon: { icon: 'ic:outline-insights' },
        envOnly: 'development',
      },
      {
        title: 'Advertising',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-promoted-listings-tab', params: { tab: 'campaigns' } },
        icon: { icon: 'ic:outline-campaign' },
        envOnly: 'development',
      },
      {
        title: 'Marketing',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-marketing-tab', params: { tab: 'promotions' } },
        icon: { icon: 'ic:outline-campaign' },
        envOnly: 'development',
      },
      {
        title: 'Listings',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-listings-tab', params: { tab: 'listings' } },
        icon: { icon: 'ic:outline-sell' },
        envOnly: 'development',
      },
      {
        title: 'Inventory API',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-inventory-tab', params: { tab: 'offers' } },
        icon: { icon: 'ic:outline-inventory-2' },
        envOnly: 'development',
      },
      {
        title: 'Store & Policies',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-store-tab', params: { tab: 'policies' } },
        icon: { icon: 'ic:outline-storefront' },
        envOnly: 'development',
      },
      {
        title: 'Orders',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-orders-tab', params: { tab: 'orders' } },
        icon: { icon: 'ic:outline-receipt-long' },
        envOnly: 'development',
      },
      {
        title: 'Messages',
        action: 'read',
        subject: 'User',
        to: 'ebay-messages',
        icon: { icon: 'ic:outline-forum' },
        envOnly: 'development',
        get badgeContent() {
          return unansweredBadge();
        },
        badgeClass: 'bg-primary',
      },
      {
        title: 'Finances',
        action: 'read',
        subject: 'User',
        to: { name: 'ebay-finances-tab', params: { tab: 'transactions' } },
        icon: { icon: 'ic:outline-account-balance-wallet' },
        envOnly: 'development',
      },
      {
        title: 'Account Health',
        action: 'read',
        subject: 'User',
        to: 'ebay-account-health',
        icon: { icon: 'ic:outline-verified-user' },
        envOnly: 'development',
      },
    ],
  },
];
